<footer class="flex-direction-column footer-lg">
  <section class="footer-top">
    <div class="footer-top-left col-6 justify-content-between">
      <div class="flex-direction-column">
        <ng-container [ngTemplateOutlet]="firstMenu"></ng-container>
      </div>
      <div class="flex-direction-column mx-2">
        <ng-container [ngTemplateOutlet]="secondMenu"></ng-container>
      </div>
      <div class="flex-direction-column">
        <ng-container [ngTemplateOutlet]="thirdMenu"></ng-container>
      </div>
    </div>

    <div class="footer-top-right">
      <div class="flex-direction-column stay-connected mx-2">
        <span class="footer-menu-title">{{ 'home-page-content.stay_connected' | translate }}</span>
        <app-social-media></app-social-media>
      </div>

      <div class="flex-direction-column mobile-app-icons align-items-center">
        <img src="assets/homepage/social-media/app-store.svg" alt="app store">
        <img src="assets/homepage/social-media/google-play.svg" alt="google play" class="mt-2">
      </div>
    </div>
  </section>
  <section class="payment-section d-flex justify-content-end">
    <app-payment-icons></app-payment-icons>
  </section>

  <section class="footer-bottom">
    <img src="assets/svg/logo.svg" alt="logo">
    <span class="footer-rights">© 2024 All rights reserved</span>
  </section>
</footer>

<section class="section-wrapper footer-mb">
  <footer class="flex-direction-column">
    <section class="footer-top flex-direction-column">
      <div class="flex-direction-row justify-content-between">
        <div class="flex-direction-column i-width-100 mr-10px">
          <div class="flex-direction-column fixed-height-150px">
            <ng-container [ngTemplateOutlet]="firstMenu"></ng-container>
          </div>
          <div class="flex-direction-column mt-5">
            <ng-container [ngTemplateOutlet]="thirdMenu"></ng-container>
          </div>
        </div>

        <div class="flex-direction-column i-width-100 ml-10px">
          <div class="flex-direction-column fixed-height-150px">
            <ng-container [ngTemplateOutlet]="secondMenu"></ng-container>
          </div>
          <div class="flex-direction-column stay-connected mt-5">
            <span class="footer-menu-title">{{ 'home-page-content.stay_connected' | translate }}</span>
            <app-social-media></app-social-media>
            <app-payment-icons class="mt-2"></app-payment-icons>
          </div>
        </div>
      </div>


      <div class="mobile-app-icons-mb flex-direction-row align-items-center justify-content-center mt-40px">
        <img src="assets/homepage/social-media/app-store.svg" alt="app store" class="mr-10px">
        <img src="assets/homepage/social-media/google-play.svg" alt="google play">
      </div>
    </section>

    <section class="footer-bottom">
      <img src="assets/svg/logo-mb.svg" alt="logo">
      <span class="footer-rights">© 2024 All rights reserved</span>
    </section>
  </footer>
</section>

<!-- TEMPLATES -->
<ng-template #firstMenu>
  <span class="footer-menu-title">{{ 'home-page-content.product' | translate }}</span>
  <span routerLink="/login" class="footer-menu-text">{{ 'home-page-content.digital_business_cards' | translate }}</span>
  <span class="footer-menu-text" routerLink="/products">{{ 'home-page-content.all_products' | translate }}</span>
</ng-template>

<ng-template #secondMenu>
  <span class="footer-menu-title">{{ 'home-page-content.company' | translate }}</span>
  <span class="footer-menu-text" routerLink="/about-us">{{ 'home-page-content.about_us' | translate }}</span>
  <span class="footer-menu-text" routerLink="/contact-us">{{ 'home-page-content.contact_us' | translate }}</span>
  <span class="footer-menu-text"
        routerLink="/privacy-policy">{{ 'home-page-content.privacy_policy' | translate }}</span>
  <span class="footer-menu-text"
        routerLink="/return-policy">{{ 'home-page-content.return_policy' | translate }}</span>
</ng-template>

<ng-template #thirdMenu>
  <span class="footer-menu-title">{{ 'home-page-content.access' | translate }}</span>
  <span class="footer-menu-text" routerLink="/login">{{ 'home-page-content.log_in' | translate }}</span>
  <span class="footer-menu-text" routerLink="/sign-up">{{ 'home-page-content.sign_up_free' | translate }}</span>
</ng-template>
